<template>
    <div class="main-custom" :style="{background: bodyBackground}">
        <div class="custom-header">
            <!--a href="#" class="bvi-open" style="position:absolute; top:15px; left:5px;">Версия сайта для слабовидящих</a-->
            <!--div class="left-head">
            </div-->
                
            <div v-if="header && header.html && header.html.length > 0" style="width:100%">
                <div v-html="header.html"></div>
                <!--div class="back-header"> 
                    <div class="head-title"> 
                        <div style="width:301px; height:52px; background:url(http://kardioservis.ru/upload/logo.png)"></div> 
                    </div>
                    <div class="head-description" style="display:flex; flex-direction:row">
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
                            <div style="height:50px; color:red; font-weight:700; display:flex; font-size: 34px; align-items:center; text-shadow: rgb(51, 51, 51) 1px 1px 2px;"><span>СЕРВИС</span></div>
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
                        </div> 
                </div-->
                <!--div style="background: linear-gradient(to top, white 48%,#d1212c 50%); display: flex;
                height: 190px;
                flex-direction: column;
                width:100%;
                margin:auto;
                background-size: cover;"> 
                    <div style="width:100%; display: flex; height: 100px; justify-content: center; align-items: center;flex-direction: column;"> 
                        <div style="width:301px; height:52px; background:url(https://telemed-radius.ddns.net/static/uploads/images/kardioservis.png)"></div>
                        <span style="opacity:0.6; font-style:italic; position:absolute; left:5px; top:1px;">Лицензия: ЛО-02-01-006055 от 19.01.2018г.</span>
                    </div>
                    <div style="background: linear-gradient( #bbb, transparent 1px), linear-gradient( #bbb, transparent 2px), linear-gradient( 90deg, #bbb, transparent 1px),  linear-gradient( 90deg, #bbb, transparent 2px);
    background-size: 15px 15px, 75px 75px;
    display:flex;
    height: 82px;
    box-shadow: 0px 0px 0px 8px rgba(0,0,0,0.2);
    flex-direction: column;
    align-items: center;">
    <div style="display:flex; flex-direction:row">
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
                            <div style="height:50px; color:red; font-weight:700; display:flex; font-size: 34px; align-items:center; text-shadow: rgb(51, 51, 51) 1px 1px 2px;"><span>СЕРВИС</span></div>
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
    </div>
                            <div style="display:flex"><span class="material-icons">phone</span><a v-b-tooltip.hover title="Кардиолог, терапевт, УЗИ" style="font-weight:600" href="tel:+79063711334">+7 (906) 37-11-334,</a> <a v-b-tooltip.hover title="Кабинет гинеколога" style="font-weight:600; margin-left:5px" href="tel:+79872515819">+7 (987) 25-15-819</a></div>
                        </div>
                </div-->
            </div>
            <div v-else style="width:100%; display:flex; justify-content:center; align-items:center" :style="colorHead()">
                <div id="logo"> </div>
                <span style="height:32px; font-size:28px; overflow-wrap:normal; text-align:center"> Медицинский центр {{$store.state.clinic.organization.form.title}}</span>
            </div>
                <!--div class="head-phone">   <div style="height:32px; font-size:22px"> <span class="material-icons">phone_in_talk</span> +7 9xx-xxx-xx-xx </div></div-->

            <!--div class="right-head">
            </div-->
            
            <span v-if="isOrgAdmin" @click="openCustomHeader()" class="material-icons settings">settings</span>
            <span v-if="isOrgAdmin" @click="openMainColor()" class="material-icons settings" style="top:40px">palette</span>
            <span v-if="isOrgAdmin" @click="openContentBackground()" class="material-icons settings" style="top:70px">group_work</span>
        </div>
        <div class="under-head" v-if="desktop">
            <div class="custom-menu" :style="backMenu()">
                <div class="custom-link" :style="colorMenu()" @click="toRoute(link)" v-for="link in custom_menu" :key="link.title">
                    <div class="in-link">{{link.title}}</div>
                </div>
                <div class="custom-link1" :style="colorMenu()" style="margin-left:auto">
                    <div class="in-link1">
                        <b-dropdown v-if="fullName" id="dropdown-form" :text="fullName" ref="dropdown">
                            <b-dropdown-form>
                                <div class="vm-userbar-menu-header">
                                    <div class="vm-userbar-menu-avatar">
                                        <img v-if="avatar" :src="avatar" alt="avatar" />
                                        <span v-else>{{ initials }}</span>
                                    </div>
                                    <div>
                                        <div class="vm-userbar-menu-title">{{ fullName }}</div>
                                    </div>
                                </div>
                            </b-dropdown-form>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item-button @click="$router.push({name: nav.name, path: nav.path ? nav.path : null, params: { clinicName: nav.clinicName ? nav.clinicName : null}})" v-for="nav in userNavTree" :key="nav.title" >{{nav.title}}</b-dropdown-item-button>
                            <b-dropdown-item-button @click="logout">Выйти</b-dropdown-item-button>
                         </b-dropdown>
                         <div @click="openLogin()" v-else>Войти</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <b-dropdown variant="info" style="width:100%">
                <template #button-content>
                    Меню
                </template>
                <b-dropdown-item  @click="toRoute(link)" v-for="link in custom_menu" :key="link.title">{{link.title}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <template v-if="fullName">
                    <b-dropdown-item-button @click="$router.push({name: nav.name, path: nav.path ? nav.path : null, params: { clinicName: nav.clinicName ? nav.clinicName : null}})" v-for="nav in userNavTree" :key="nav.path" >{{nav.title}}</b-dropdown-item-button>
                    <b-dropdown-item-button @click="logout">Выйти</b-dropdown-item-button>
                </template>
                <b-dropdown-item-button v-else @click="openLogin()">Войти</b-dropdown-item-button>
            </b-dropdown>
        </div>
        <div id="content" v-if="itsMainPage()">
        <div class="present">
            <div class="left-present">
                <b-carousel class="bvi-hide"
                    id="carousel-1"
                    :interval="0"
                    controls
                    indicators
                    background="transparent"
                    :img-width="desktop ? 500 : 350"
                    :img-height="desktop ? 300 : 150"
                    style="text-shadow: 1px 1px 2px #333; width:700px;  border-radius:15px"
                    :style="{height: desktop ? '450px': '150px'}"
                    >
                    <!-- Text slides with image  background="#e9ecef" img-blank  -->
                    <!--b-carousel-slide
                       img-height="300" background="transparent" img-src="https://avatars.mds.yandex.net/get-altay/876204/2a00000161471bcb92822579cbcd9fd052db/XXXL"
                    >
                        <h1>{{$store.state.clinic.organization.form.title}} </h1>
                            <p>
                            Многопрофильный медицинский центр – самый современный институт в российской системе здравоохранения, подразумевающий большой выбор услуг и высокий уровень сервиса.
                            </p>
                        <hr class="my-4">
                        <b-button variant="primary" href="#">Записаться к врачу</b-button>
                        <b-button variant="success" href="#">Войти в личный кабинет</b-button>
                        <span v-if="isOrgAdmin" class="material-icons settings" @click="openEditPresent()">settings</span>
                    </b-carousel-slide-->
                    <b-carousel-slide
                        img-height="300" background="transparent" :img-src="present.background ? present.background : 'http://telemed-radius.ddns.net/static/uploads/images/6427690c-3ebc-4fe4-8fc4-42cf95b2c56d.png'"
                        v-for="present in presents" :key="present.headText"
                    >
                        <h1>{{present.headText}}</h1>
                        <p> {{present.description}} </p>
                        <template v-if="present.paths.length > 0">
                            <hr class="my-4">
                            <b-button variant="primary" v-for="link in present.paths" :key="link.path" :href="link.path">{{link.title}}</b-button>
                        </template>
                        <span v-if="isOrgAdmin" class="material-icons settings" @click="openEditPresent(present)">settings</span>
                        <span v-if="isOrgAdmin" class="material-icons settings" title="удалить" style="top:35px" @click="deletePresent(present)">delete</span>
                    </b-carousel-slide>
                    <b-carousel-slide v-if="isOrgAdmin"
                        img-blank img-height="300" background="#e9ecef"
                    >
                        <span @click="open_present = true" class="material-icons" style="cursor:pointer">add добавить</span>
                    </b-carousel-slide>
                </b-carousel>
                <div class="under-present">
                    <div class="anyPresent-left" @click="infoblock(4) ? infoblock(4).path ? $router.push({ path: infoblock(4).path}) : $router.push({path: '/'}) : $router.push({path: '/'})" :style="{ background: infoblock(4) ? infoblock(4).background ?  `url(${infoblock(4).background}) 0% 0% / cover` : 'none' : 'none'}">
                        <span v-if="isOrgAdmin" @click.stop.prevent="openInfoBlock(4)" class="material-icons settingsBlock" title="настроить блок">settings</span>
                        <template v-if="infoblock(4)">
                            <h4>{{infoblock(4).headText}}</h4>
                            <div class="description">{{infoblock(4).description}}</div>
                        </template>
                    </div>
                    <div class="anyPresent-left" @click="infoblock(5) ? infoblock(5).path ? $router.push({ path: infoblock(5).path}) : $router.push({path: '/'}) : $router.push({path: '/'})" :style="{ background: infoblock(5) ? infoblock(5).background ?  `url(${infoblock(5).background}) 0% 0% / cover` : 'none' : 'none'}">
                        <span v-if="isOrgAdmin" @click.stop.prevent="openInfoBlock(5)" class="material-icons settingsBlock" title="настроить блок">settings</span>
                        <template v-if="infoblock(5)">
                            <h4>{{infoblock(5).headText}}</h4>
                            <div class="description">{{infoblock(5).description}}</div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="right-present">
                <div class="anyPresent" @click="infoblock(1) ? infoblock(1).path ? $router.push({ path: infoblock(1).path}) : $router.push({path: '/'}) : $router.push({path: '/'})" :style="{ background: infoblock(1) ? infoblock(1).background ? `url(${infoblock(1).background})` : 'none' : 'none', 'background-size': 'cover'}">
                    <span v-if="isOrgAdmin" @click.stop.prevent="openInfoBlock(1)" class="material-icons settingsBlock" title="настроить блок">settings</span>
                    <template v-if="infoblock(1)">
                        <h4>{{infoblock(1).headText}}</h4>
                        <div class="description">{{infoblock(1).description}}</div>
                    </template>
                </div>
                    <div class="anyPresent" @click="infoblock(2) ? infoblock(2).path ? $router.push({ path: infoblock(2).path}) : $router.push({path: '/'}) : $router.push({path: '/'})" :style="{ background: infoblock(2) ? infoblock(2).background ?  `url(${infoblock(2).background})` : 'none' : 'none', 'background-size': 'cover'}">
                        <span v-if="isOrgAdmin" @click.stop.prevent="openInfoBlock(2)" class="material-icons settingsBlock" title="настроить блок">settings</span>
                        <template v-if="infoblock(2)">
                            <h4>{{infoblock(2).headText}}</h4>
                            <div class="description">{{infoblock(2).description}}</div>
                        </template>
                </div>
                <div class="anyPresent" @click="infoblock(3) ? infoblock(3).path ? $router.push({ path: infoblock(3).path}) : $router.push({path: '/'}) : $router.push({path: '/'})" :style="{ background: infoblock(3) ? infoblock(3).background ?  `url(${infoblock(3).background})` : 'none' : 'none', 'background-size': 'cover'}">
                        <span v-if="isOrgAdmin" @click.stop.prevent="openInfoBlock(3)" class="material-icons settingsBlock" title="настроить блок">settings</span>
                        <template v-if="infoblock(3)">
                            <h4>{{infoblock(3).headText}}</h4>
                            <div class="description">{{infoblock(3).description}}</div>
                        </template>
                </div>
            </div>
        </div>
        <div class="uslugi">
            <h4>Наши услуги</h4>
            <b-list-group horizontal style="padding:1rem">
                <!--b-list-group-item>Кардиолог</b-list-group-item>
                <b-list-group-item>УЗИ</b-list-group-item>
                <b-list-group-item>Невролог</b-list-group-item-->
                <b-list-group-item v-for="service in services" :key="service.text" 
                :style="{background: service.file ? 'url('+ service.file + ')' : service.gradient ? service.background : 'none', 
                'background-image': !service.file ? `url(https://telemed-radius.ddns.net/static/uploads/images/tablet-back2.png)`:'url('+ service.file + ')',
                'background-color': service.color && !service.gradient ? service.color : 'none',
                'color': service.textColor ? service.textColor : 'black',
                'font-size': service.textSize ? service.textSize + 'px' : '16px'
                }"
                @click="$router.push({name: 'patients', query: {page:service.text}})"
                >{{service.text}}
                    <span v-if="isOrgAdmin" @click="deleteService(service)" class="material-icons delete-service" title="удалить" >close</span>
                    <span v-if="isOrgAdmin" @click="openEditService(service)" title="изменить" class="material-icons edit-service">edit</span>
                </b-list-group-item>
                <b-list-group-item v-if="isOrgAdmin" class="add-service" @click="open_service = true"><span class="material-icons">add</span></b-list-group-item>
            </b-list-group>
        </div>
        <div class="team">
            <h4>Наши специалисты</h4>
            <swiper ref="mySwiper" class="swiper" :options="swiperOption">
                <swiper-slide v-for="doctor in doctors" :key="doctor.id">
            <b-card 
                :title="doctor.employee.lastName + ' ' + doctor.employee.firstName + ' ' + doctor.employee.middleName"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 20rem; min-width:18rem;"
                class="mb-2 swiper-slide"
            >
            <template #header>
                <img v-if="doctor.employee.avatar" :src="doctor.employee.avatar" style="max-width:100%; border-radius: 50%; height:250px"/>
                <template v-else>
                    <photo style="width:100%; height:250px; color:gray" />
                </template>
            </template>
                <b-card-text>
                    {{doctor.specialty.title}} <template v-if="doctor.experience">, стаж {{doctor.experience}} лет. </template> <template v-else>.</template>
                </b-card-text>

                <b-button @click="$router.push({name: 'currentSpecialist', params: {id: doctor.id}})" variant="primary">Записаться</b-button>
            </b-card>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
        <div class="reviews">
            <h4>Отзывы <span v-if="isOrgAdmin" @click="openYandexReview = true" class="material-icons edit-review">edit</span></h4>
            <div class="yandex-review"> <!--:style="{'max-height': more ? 'fit-content': '400px'}"-->
                <div v-html="yandexReviews"></div>
                <!--span @click="$router.push({name: 'reviews'})" class="more">Посмотреть все</span-->
            </div>
            <!--div class="yandex-review" :style="{'max-height': more ? 'fit-content': '400px'}">
                <iframe style="width:100%;height:100%;border:1px solid #e6e6e6;border-radius:8px;box-sizing:border-box" src="https://yandex.ru/maps-reviews-widget/160278145756?comments"></iframe><a href="https://yandex.ru/maps/org/kardioservis/160278145756/" target="_blank" style="box-sizing:border-box;text-decoration:none;color:#b3b3b3;font-size:10px;font-family:YS Text,sans-serif;padding:0 20px;position:absolute;bottom:8px;width:100%;text-align:center;left:0">КардиоСервис на карте Нефтекамска — Яндекс.Карты</a>
                <span @click="more = !more" class="more"><template v-if="!more">Посмотреть все</template><template v-else>Свернуть</template></span>
            </div-->
            <!--
            <h4>Отзывы</h4>
            <swiper class="swiper-review" :options="swiperOptionReview">
                <swiper-slide v-for="review in reviews" :key="review.id">
                    <div class="review">
                        <img src="https://html5css.ru/howto/img_avatar.png" alt="Avatar" style="width:90px; height:90px">
                        <div style="width:100%; overflow:auto; max-height:180px">
                            <p><span>{{review.fullName}}</span></p>
                            <p>{{review.text}}</p>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            -->
        </div>
        <div class="licenses">
            <h4>Лицензии</h4>
            <swiper class="swiper-license" :options="swiperOption">
                <swiper-slide v-for="license in licenses" :key="license.title"> 
                    <div class="license" :title="license.title" @click="openImageLicense(license.img)">
                        <img :src="license.img" :alt="license.title" style="width:200px; height:282px">
                        <span v-if="isOrgAdmin" class="material-icons del-lic" @click="deleteLicense(license)">close</span>
                    </div>
                </swiper-slide>
                <swiper-slide v-if="isOrgAdmin">
                    <div class="license add-lic" @click="open_license = true">
                            <span class="material-icons" style="opacity:0.6; color:gray; font-size:54px">library_add</span>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
        </div>

        <Dialog v-if="open_service">
            <h4 slot="header">Добавить услугу:</h4>
            <div slot="body">
            <div class="row"> <span>Текст: </span>
                <b-form-input type="text" v-model="formNewService.text"></b-form-input>
                <span>Размер текста: </span>
                <b-form-input type="number" v-model="formNewService.textSize"></b-form-input>
                <span>Цвет текста: </span>
                <b-form-input type="color" v-model="formNewService.textColor"></b-form-input>
            </div>
            <div class="row"> <span>Цвет фона: </span>
                <b-form-input type="color" v-model="formNewService.color"></b-form-input>
                <b-form-input v-if="formNewService.gradient" type="color" v-model="formNewService.color2"></b-form-input>
                <b-form-checkbox v-model="formNewService.gradient" name="check-button" switch>
                    Градиент
                </b-form-checkbox>
                <span v-if="formNewService.totop==='top'" @click="togradient('right')" class="material-icons" style="cursor:pointer">
                    gradient
                </span>
                <span v-else class="material-icons" @click="togradient('top')" style="transform: rotate(90deg); cursor:pointer">
                    gradient
                </span>
            </div>
            <div class="row"> <span>Картинка в фоне: </span>
            <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Выбрать файл..."
                drop-placeholder="Drop file here..."
                @input="uploadImage"
                ></b-form-file>
            </div>
            </div>
            <div slot="footer">
                <b-button variant="info" @click="current_service ? edit_service() : add_service()">Сохранить</b-button>
                <b-button variant="danger" @click="closeForm();">Отменить</b-button>
            </div>
        </Dialog>
         <Dialog v-if="open_present">
            <h4 slot="header">Добавить описание(новость):</h4>
            <div slot="body">
                <div class="row"> <span>Оглавнение: </span>
                    <b-form-input type="text" v-model="formNewPresent.headText"></b-form-input>
                    <span>Описание: </span>
                    <b-form-textarea type="text" multiline v-model="formNewPresent.description"></b-form-textarea>
                    <span>Фон: </span>
                    <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Выбрать файл..."
                    drop-placeholder="Drop file here..."
                    @input="uploadImage"
                    ></b-form-file>
                </div>
                <div>
                    <span >Ссылки</span>
                    <div v-for="(link, index) in formNewPresent.paths" :key="index" style="display:flex; justify-content:space-evenly"><div>Наименование: <b-form-input type="text" v-model="link.title"></b-form-input></div> 
                    <div>ссылка:<b-form-input type="text" v-model="link.path"></b-form-input> </div><span @click="formNewPresent.paths.splice(index, 1)" class="material-icons" style="cursor:pointer; display:flex; align-items:center">close</span></div>
                </div>
                <div><span class="material-icons" @click="formNewPresent.paths.push({title: null, path:null})" style="font-size:16px; cursor:pointer">add добавить</span></div>
            </div>
            <div slot="footer">
                    <b-button variant="info" @click="current_present ? edit_present() : add_present()">Сохранить</b-button>
                    <b-button variant="danger" @click="closePresent()">Отменить</b-button>
            </div>
         </Dialog>
         <Dialog v-if="openInfoblock">
             <h4 slot="header">Добавить описание(в {{current_infoblock.id}} блок):</h4>
            <div slot="body">
                <div class="row"> <span>Оглавнение: </span>
                    <b-form-input type="text" v-model="formNewInfoblock.headText"></b-form-input>
                    <span>Описание: </span>
                    <b-form-textarea type="text" multiline v-model="formNewInfoblock.description"></b-form-textarea>
                    <span>Ссылка:</span><b-form-input type="text" v-model="formNewInfoblock.path"></b-form-input>
                    <span>Фон:</span><b-form-file
                        v-model="file"
                        :state="Boolean(file)"
                        placeholder="Выбрать файл..."
                        drop-placeholder="Drop file here..."
                        @input="uploadImage"
                        ></b-form-file>
                </div>
            </div>
            <div slot="footer">
                    <b-button variant="info" @click="edit_infoblock()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeInfoblock()">Отменить</b-button>
            </div>
         </Dialog>
         <Dialog v-if="open_license">
             <h4 slot="header">Добавить лицензию</h4>
            <div slot="body">
                <div class="row"> 
                    <span>Описание: </span>
                    <b-form-input type="text" v-model="formNewLicense.title"></b-form-input>
                    <span>Изображение: </span>
                    <b-form-file
                        v-model="file"
                        :state="Boolean(file)"
                        placeholder="Выбрать файл..."
                        drop-placeholder="Drop file here..."
                        @input="uploadImage"
                    ></b-form-file>
                </div>
            </div>
            <div slot="footer">
                    <b-button variant="info" :disabled="!url_image" @click="add_license()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeLicense()">Отменить</b-button>
            </div>
         </Dialog>

         <Dialog v-if="openHeader">
             <h4 slot="header">Добавить своё оформление оглавнения (html)</h4>
            <div slot="body">
                <div class="row"> 
                    <span>Код: </span>
                    <b-form-textarea type="text" multiline v-model="formNewHeader.html"></b-form-textarea>
                    <span>favicon: </span>
                    <b-form-textarea type="text" v-model="formNewHeader.favicon"></b-form-textarea>
                </div>
            </div>
            <div slot="footer">
                    <b-button variant="info" @click="edit_custom_header()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeHeader()">Отменить</b-button>
            </div>
         </Dialog>

         <Dialog v-if="open_main_color">
             <h4 slot="header">Выбрать главные цвета</h4>
             <div slot="body">
                 <div class="row">
                     <span>Основной цвет:</span>
                     <b-form-input type="color"  v-model="formNewMainColor.mainColor"></b-form-input>
                    <span>Цвет текста:</span>
                     <b-form-input type="color" v-model="formNewMainColor.textColor"></b-form-input>
                 </div>
             </div>
             <div slot="footer">
                    <b-button variant="info" @click="edit_main_color()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeMainColor()">Отменить</b-button>
            </div>
         </Dialog>

         <Dialog v-if="isContentBackground">
             <h4 slot="header">Выбрать фон</h4>
             <div slot="body">
                 <b-form-group label="Опция">
                    <b-form-radio v-model="typeBack" name="some-radios" value="color">Цвет</b-form-radio>
                    <b-form-radio v-model="typeBack" name="some-radios" value="file">Изображение</b-form-radio>
                </b-form-group>
                <div v-if="typeBack === 'color'">
                    <b-form-input type="color"  v-model="contentBackground"></b-form-input>
                </div>
                <div v-else>
                    <b-form-file
                        v-model="file"
                        :state="Boolean(file)"
                        placeholder="Выбрать файл..."
                        drop-placeholder="Drop file here..."
                        @input="uploadImage"
                    ></b-form-file>
                </div>
             </div>
             <div slot="footer">
                    <b-button variant="info" @click="edit_content_background()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeContentBackground()">Отменить</b-button>
            </div>
         </Dialog>
         <Dialog v-if="openYandexReview">
             <h4 slot="header">Добавьте код Яндекс.Карт</h4>
             <div slot="body">
                 <div class="row"> 
                    <span>Код: </span>
                    <b-form-textarea type="text" multiline v-model="reviewsYandex"></b-form-textarea>
                </div>
             </div>
            <div slot="footer">
                <b-button variant="info" @click="edit_YandexReviews()">Сохранить</b-button>
                <b-button variant="danger" @click="closeYandexReviews()">Отменить</b-button>
            </div>
         </Dialog>
         <Dialog v-if="openYandexMap">
             <h4 slot="header">Добавьте код Яндекс.Карт</h4>
             <div slot="body">
                 <div class="row"> 
                    <span>Код: </span>
                    <b-form-textarea type="text" multiline v-model="mapYandex"></b-form-textarea>
                </div>
             </div>
            <div slot="footer">
                <b-button variant="info" @click="edit_YandexMap()">Сохранить</b-button>
                <b-button variant="danger" @click="closeYandexMap()">Отменить</b-button>
            </div>
         </Dialog>
         <router-view/>
         <div class="maps" id="contact">
             <div class="footer-menu">
                 <ul>
                     <li v-for="link in custom_menu" :key="link.title"><a @click="toRoute(link)">{{link.title}}</a></li>
                 </ul>
             </div>
             <div class="conts">
                <div style="color:white; margin:1rem">
                    <h5 style="text-decoration: underline;">Контакты</h5>
                    <h5>{{$store.state.clinic.organization.form.title}}</h5>
                    <div style="margin-bottom:1rem">
                        <span style="font-weight:600; text-decoration: underline;">Адрес:</span> <span style="margin-left:5px">  {{$store.state.clinic.organization.form.address}}</span>
                    </div>
                    <div style="margin-bottom:1rem">
                        <span style="font-weight:600; text-decoration: underline;">Телефоны:</span><span style="white-space: break-spaces; margin-left:5px">  {{$store.state.clinic.organization.form.phones}}</span>
                    </div>
                    <span style="font-weight:600; text-decoration: underline;">Время работы:</span><span style="white-space: break-spaces; margin-left:5px">  {{$store.state.clinic.organization.form.worktime}}</span>
                    <br>
                    <b-button v-if="isOrgAdmin" @click="openYandexMap = true;">Добавить карту</b-button>
                </div>
                <div v-if="desktop" v-html="mapClinic"></div>
                <!--div style="position:relative;overflow:hidden;"><a href="https://yandex.ru/maps/org/kardioservis/160278145756/?utm_medium=mapframe&utm_source=maps" style="color:#eee;font-size:12px;position:absolute;top:0px;">КардиоСервис</a><iframe src="https://yandex.ru/map-widget/v1/-/CCUEm0w0KA" width="560" height="400" frameborder="1" allowfullscreen="true" style="position:relative;"></iframe></div-->
             </div>
         </div>
    </div> 
</template>

<script>
import slider from '../../plugins/vue-slider';
import Dialog from '@app/views/custom-components/modals/edit-modal';
import { doctorApi, http, laravelHttp, organizationApi, uploadImageApi } from '@app/services';
import photo from '@app/assets/icons/camera.svg?inline';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    components: {
        Dialog,
        photo,
        Swiper,
        SwiperSlide
    },
    directives: {
    swiper: directive
  },
    data() {
        return {
            desktop: null,
            swiperOption: {
          slidesPerView: 'auto', //window.outerWidth <= 1024 ? 1 : 3,
          spaceBetween: 0,
          //slidesPerGroup: 4,
          loop: false,
          loopFillGroupWithBlank: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
          // ...
        },
        swiperOptionReview: {
          slidesPerView: 'auto', // window.outerWidth <= 1024 ? 1 : 2,
          spaceBetween: 0,
          loop: true,
          loopFillGroupWithBlank: false,
          autoplay: {
            delay: 5500,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        options: {
                items: 2,
                margin: 20,
                nav: true,
                dots: false,
                loop: false,
                timing: 'cubic-bezier(0, 0.72, 0.64, 1.06)',
                offset: 1,
                prevNav: '<',
                nextNav: '>',
                sibling: true,
                responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                999: {
                    items: 2
                }
                }
            },
            open_service: false,
            open_present: false,
            open_license: false,
            openInfoblock: false,
            openHeader: false,
            open_main_color: false,
            isContentBackground: false,
            openYandexReview: false,
            openYandexMap: false,
            contentBackground: null,
            typeBack: 'color',
            more: false,
            formNewService: {
                text: null,
                textColor: '#ffff',
                textSize: 16,
                background: null,
                color: null,
                color2: null,
                gradient: false,
                totop: 'top',
                file: null,
            },
            formNewPresent: {
                headText: null,
                description: null,
                paths: [],
                background: null,
            },
            formNewLicense: {
                title: null,
                img: null
            },
            formNewInfoblock: {
                id: null,
                headText: null,
                description: null,
                path: null,
                background: null
            },
            formNewHeader: {
                html: null,
                favicon: null
            },
            formNewMainColor: {
                mainColor: '#000000',
                textColor: '#000000',
            },
            doctors: [],
            file: null,
            url_image: null,
            current_service: null,
            current_present: null,
            current_infoblock: null,
            current_infoblockId: null,
            custom_menu: this.setMainMenu(),
            userNavTree: this.setUserMenu(),
            reviewsYandex: null,
            mapYandex: null,
            reviews: [
                {
                    id: 1,
                    fullName: 'Олег Потапов',
                    text: 'Рекомендую! Отличная клиника'
                },
                {
                    id: 2,
                    fullName: 'Кристина Стрельцова',
                    text: 'Вежливый персонал и квалифицированные специалисты!'
                },
                {
                    id: 3,
                    fullName: 'Валерия Стрельцова',
                    text: `Ответственный персонал и квалифицированные врачи! Многопрофильный медицинский центр – самый современный институт в российской системе здравоохранения, подразумевающий большой выбор услуг и высокий уровень сервиса. Это качественно новый подход к консультированию, обследованию и лечению пациента. 

Индивидуальный подход врачей-кардиологов «Кардио» позволит вам избежать многих проблем, пройти своевременную диагностику и, если потребуется, получить высококвалифицированное лечение.`
                }
            ],
            test: `<div style="background: linear-gradient(to top, white 48%,#d1212c 50%); display: flex;
                height: 190px;
                flex-direction: column;
                width:100%;
                margin:auto;
                background-size: cover;"> 
                    <div style="width:100%; display: flex; height: 100px; justify-content: center; align-items: center;flex-direction: column;"> 
                        <div style="width:301px; height:52px; background:url(https://telemed-radius.ddns.net/static/uploads/images/97cb0875-0426-4831-91bf-b757ea04f9b9.png)"></div> 
                    </div>
                    <div style="background: linear-gradient( #bbb, transparent 1px), linear-gradient( #bbb, transparent 2px), linear-gradient( 90deg, #bbb, transparent 1px),  linear-gradient( 90deg, #bbb, transparent 2px);
    background-size: 15px 15px, 75px 75px;
    display:flex;
    height: 82px;
    box-shadow: 0px 0px 0px 8px rgba(0,0,0,0.2);
    flex-direction: row;
    justify-content: center;">
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
                            <div style="height:50px; color:red; font-weight:700; display:flex; font-size: 34px; align-items:center; text-shadow: rgb(51, 51, 51) 1px 1px 2px;"><span>СЕРВИС</span></div>
                            <div style="width:100px; height:50px; background:url(http://telemed-radius.ddns.net/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)">
                            </div>
                        </div> 
                </div>`
        };
    },
    computed: {
        services() {
            return this.$store.state.clinic.organization.form.front.services;
        },
        presents() {
            return this.$store.state.clinic.organization.form.front.presents;
        },
        licenses() {
            return this.$store.state.clinic.organization.form.front.licenses;
        },
        fullName() {
            return this.$store.state.permission.userName;
        },
         avatar() {
            return this.$store.state.permission.avatar;
        },
        initials() {
            return this.$store.state.permission.userInitials;
        },
        header() {
            //return this.$store.state.clinic.organization.form.front.header;
            return {'html': '<div style=\'background: linear-gradient(to top, white 48%,#d1212c 50%); display: flex;\n                height: 190px;\n                flex-direction: column;\n                width:100%;\n                margin:auto;\n                background-size: cover;\'> \n                    <div style=\'width:100%; display: flex; height: 100px; justify-content: center; align-items: center;flex-direction: column;\'> \n                        <div style=\'width:301px; height:52px; background:url(https://radius-lab.ru/static/uploads/images/kardioservis.png)\'></div>\n                        <span style=\'opacity:0.6; font-style:italic; position:absolute; left:5px; top:1px;\'>Лицензия: ЛО-02-01-006055 от 19.01.2018г.</span>\n                    </div>\n                    <div style=\'background: linear-gradient( #bbb, transparent 1px), linear-gradient( #bbb, transparent 2px), linear-gradient( 90deg, #bbb, transparent 1px),  linear-gradient( 90deg, #bbb, transparent 2px);\n    background-size: 15px 15px, 75px 75px;\n    display:flex;\n    height: 82px;\n    box-shadow: 0px 0px 0px 8px rgba(0,0,0,0.2);\n    flex-direction: column;\n    align-items: center;\'>\n    <div style=\'display:flex; flex-direction:row\'>\n                            <div style=\'width:100px; height:50px; background:url(https://radius-lab.ru/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)\'>\n                            </div>\n                            <div style=\'height:50px; color:red; font-weight:700; display:flex; font-size: 34px; align-items:center; text-shadow: rgb(51, 51, 51) 1px 1px 2px;\'><span>СЕРВИС</span></div>\n                            <div style=\'width:100px; height:50px; background:url(https://radius-lab.ru/static/uploads/images/8455bced-f399-4b20-9988-f44cea4b7515.svg)\'>\n                            </div>\n    </div>\n                            <div style=\'display:flex\'><span class=\'material-icons\'>phone</span><a v-b-tooltip.hover title=\'Кардиолог, терапевт, УЗИ\' style=\'font-weight:600\' href=\'tel:+79063711334\'>+7 (906) 37-11-334,</a> <a v-b-tooltip.hover title=\'Кабинет гинеколога\' style=\'font-weight:600; margin-left:5px\' href=\'tel:+79872515819\'>+7 (987) 25-15-819</a></div>\n                        </div>\n                </div>', 'favicon': 'https://kardioservis.ru/static/uploads/images/faviconKardio.ico'};
        },
        customColor() {
            return this.$store.state.clinic.organization.form.front.mainColor;
        },
        bodyBackground() {
            return this.$store.state.clinic.organization.form.front.contentBackground;
        },
        isOrgAdmin() {
            const role = this.$store.state.clinic.roles.filter(obj => obj === 'orgadmin')[0];
            return role ? true : false;
        },
        yandexReviews() {
            return this.$store.state.clinic.organization.form.front.reviews;
        },
        mapClinic() {
            return this.$store.state.clinic.organization.form.front.map;
        }
    },
    created() {
        window.addEventListener('resize', this.resizeHandler);
        if (this.$store.state.navigation.site) {
            if (this.$store.state.permission.resources) {
                if (this.$store.state.permission.resources.organization) {
                    if (this.$store.state.permission.resources.organization[this.$store.state.clinic.id]) {
                    this.$store.commit('clinic/setRoles', this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles);
                    }
                }
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeHandler);
        document.removeEventListener('click', this.close_bvi);
    },
    mounted() {
        const bvi = document.getElementById('bvi').style;
        bvi.display = 'block';
        doctorApi.getAll().then(res => {
            if(this.$store.state.navigation.site === 'kardioservis.ru') {
                this.doctors = [ res.items.find(o => o.employee.lastName === 'Загирова'), 
                res.items.find(o => o.employee.lastName === 'Минуллина'),
                res.items.find(o => o.employee.lastName === 'Фасхутдинова'),
                res.items.find(o => o.employee.lastName === 'Ахметшина'),
                res.items.find(o => o.employee.lastName === 'Загиров'),
                res.items.find(o => o.employee.lastName === 'Галиева'),
                res.items.find(o => o.employee.lastName === 'Хакимова'),
                res.items.find(o => o.employee.lastName === 'Юсупова'),
                res.items.find(o => o.employee.lastName === 'Фахретдинова'),
                res.items.find(o => o.employee.lastName === 'Гарифуллина'),
                res.items.find(o => o.employee.lastName === 'Каюмова')
                ];
            } else {
                this.doctors = res.items;
            }
        }).catch(error => {
            console.log(error);
        });
        this.desktop = window.innerWidth > 1100;
        document.getElementsByClassName('bvi-open')[0].addEventListener('click', this.close_bvi);
    },
    methods: {
        close_bvi() {
            const bvi_close = document.getElementsByClassName('bvi-panel-close')[0].style;
            bvi_close.position = 'absolute';
            bvi_close.top = '150px';
        },
        closeForm() {
            this.open_service = false; 
            this.formNewService.text = null;
            this.formNewService.color = null;
            this.formNewService.file = null;
            this.formNewService.color2 = null;
            this.formNewService.background = null;
            this.formNewService.gradient = false;
            this.formNewService.totop = 'top';
            this.formNewService.textColor = '#ffff';
            this.url_image = null;

        },
        closePresent() {
            this.open_present = false;
            this.formNewPresent.paths = [];
            this.formNewPresent.headText = null;
            this.formNewPresent.description = null;
            this.formNewPresent.background= null;
            this.url_image = null;
        },
        closeInfoblock() {
            this.openInfoblock = false;
            this.formNewInfoblock.headText = null;
            this.formNewInfoblock.description = null;
            this.formNewInfoblock.path = null;
            this.formNewInfoblock.background = null;
            this.url_image = null;
        },
        closeLicense() {
            this.open_license = false;
            this.formNewLicense.title = null;
            this.formNewLicense.img = null;
            this.url_image = null;
        },
        closeHeader() {
            this.openHeader = false;
            this.formNewHeader.html = null;
            this.formNewHeader.favicon = null;
        },
        closeMainColor() {
            this.open_main_color = false;
            this.formNewMainColor.mainColor = '#000000';
            this.formNewMainColor.textColor = '#000000';
        },
        closeContentBackground() {
            this.isContentBackground = false;
            this.contentBackground = null;
        },
        closeYandexReviews() {
            this.openYandexReview = false;
            this.reviewsYandex = null;
        },
        closeYandexMap() {
            this.openYandexMap = false;
            this.mapYandex = null;
        },
        add_service() {
            const front = this.$store.state.clinic.organization.form.front;
            if (this.formNewService.gradient) {
                this.formNewService.background = `linear-gradient(to ${this.formNewService.totop}, ${this.formNewService.color}, ${this.formNewService.color2})`;
            }
            this.formNewService.file = this.url_image;
            if (front.services) {
                front.services.push(Object.assign({}, this.formNewService));
            } else {
                front.services = [];
                front.services.push(Object.assign({}, this.formNewService));
            }
            organizationApi.update({front: front}).then(res => {
                console.log(res);
                this.open_service = false;
                this.closeForm();
            }).catch(error => {
                console.log(error);
                front.services.splice(front.services.length-1,1);
            });
            console.log(front);
        },
        edit_service() {
            const front = this.$store.state.clinic.organization.form.front;
            if (!this.formNewService.background) {
             if (this.formNewService.gradient) {
                this.formNewService.background = `linear-gradient(to ${this.formNewService.totop}, ${this.formNewService.color}, ${this.formNewService.color2})`;
            }
            }
            this.formNewService.file = this.url_image;
            front.services[front.services.findIndex(obj => obj.text === this.current_service.text)] = Object.assign({}, this.formNewService);
            organizationApi.update({front: front}).then(res => {
                console.log(res);
                this.open_service = false;
                this.current_service = null;
                this.closeForm();
            }).catch(error => {
                console.log(error);
                front.services[front.services.findIndex(obj => obj.text === this.formNewService.text)] = this.current_service;
            });
        },
        openEditService(service) {
            this.open_service = true;
            this.current_service = service;
            this.formNewService = Object.assign({}, service);
            if (!this.formNewService.totop) {
               // this.formNewService.gradient = false;
                this.formNewService.totop = 'top';
            }
            console.log(this.formNewService, service);
        },
        deleteService(service) {
            const front = this.$store.state.clinic.organization.form.front;
            front.services = front.services.filter(obj => obj.text !== service.text);
            organizationApi.update({front: front});
        },
        async uploadImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            //this.formNewService.file = await uploadImageApi.upload(formData);
            this.url_image = await uploadImageApi.upload(formData);
        },
        togradient(evt) {
            this.formNewService.totop = evt;
        },
        toRoute(link) {
            const route = {
                name: link.name,
                path: link.path ? link.path: null,
                params: { 
                    clinicName: link.clinicName ? link.clinicName: null
                }
            };
            if (link.name==='contact') {
                this.$router.push(route);
                const elm = document.getElementById('contact');
                elm.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'});
            } else {
                this.$router.push(route);
            }
        },
        openLogin() {
            this.$router.push({path: '/'});
            this.$store.commit('navigation/setLoginDialog', true);
        },
        logout() {
        try {
                this.$store.dispatch('auth/resetAuthUserDetail');
                http.removeToken();
                laravelHttp.removeToken();
                this.$store.commit('permission/removeResources');
                this.$store.commit('permission/setUserName', null);
                this.$store.commit('clinic/setRoles', []);
                this.$router.push('/');
            } catch (e) {
                console.error(e);
            }
        },
        openEditPresent(present) {
            this.open_present = true;
            if (present) {
                this.current_present = present;
                this.formNewPresent = Object.assign({}, present);
            }
        },
        deletePresent(present) {
            const front = this.$store.state.clinic.organization.form.front;
            front.presents = front.presents.filter(obj => obj.headText !== present.headText);
            organizationApi.update({front: front});
        },
        add_present() {
            const front = this.$store.state.clinic.organization.form.front;
            this.formNewPresent.background = this.url_image;
            if (front.presents) {
                front.presents.push(Object.assign({}, this.formNewPresent));
            } else {
                front.presents = [];
                front.presents.push(Object.assign({}, this.formNewPresent));
            }
            organizationApi.update({front: front}).then(res => {
                this.open_present = false;
                this.closePresent();
            }).catch(error => {
                console.log(error);
                front.presents.splice(front.presents.length-1,1);
            });
        },
        edit_present() {
            const front = this.$store.state.clinic.organization.form.front;
            front.presents[front.presents.findIndex(obj => obj.headText === this.current_present.headText)] = Object.assign({}, this.formNewPresent);
            organizationApi.update({front: front}).then(res => {
                this.open_present = false;
                this.current_present = null;
                this.closePresent();
            }).catch(error => {
                console.log(error);
                front.presents[front.presents.findIndex(obj => obj.headText === this.formNewPresent.headText)] = this.current_present;
            });
        },
        infoblock(id) {
            if (this.$store.state.clinic.organization.form.front.infoblocks) {
                const block = this.$store.state.clinic.organization.form.front.infoblocks.find(obj => obj.id===id);
                const data = this.$store.state.clinic.organization.form.front.infoblocks ? 
                block ? block : this.formNewInfoblock : null;
                return data;
            } else {
                return [];
            }
        },
        openInfoBlock(id) {
            this.openInfoblock = true;
            this.current_infoblockId = id;
            console.log(this.infoblock(id));
            if (this.infoblock(id)) {
               this.current_infoblock = this.infoblock(id);
                this.formNewInfoblock = Object.assign({}, this.infoblock(id));
            }
        },
        edit_infoblock() {
            const front = this.$store.state.clinic.organization.form.front;
            this.formNewInfoblock.background = this.url_image;
            this.formNewInfoblock.id = this.current_infoblockId;
            if (!front.infoblocks) {
                front.infoblocks = [];
                front.infoblocks.push(Object.assign({}, this.formNewInfoblock));
            } else {
                //front.infoblocks.push(Object.assign({}, this.formNewInfoblock));
                front.infoblocks[front.infoblocks.findIndex(obj => obj.id === this.formNewInfoblock.id)] = Object.assign({}, this.formNewInfoblock);
            }
            organizationApi.update({front: front}).then(res => {
                this.openInfoblock = false;
                this.current_infoblock = null;
                this.closeInfoblock();
            }).catch(error => {
                console.log(error);
                front.infoblocks[front.infoblocks.findIndex(obj => obj.id === this.formNewInfoblock.id)] = this.current_present;
            });
        },
        
        add_license() {
            const front = this.$store.state.clinic.organization.form.front;
            this.formNewLicense.img = this.url_image;
            if (!front.licenses) {
                front.licenses = [];
                front.licenses.push(Object.assign({}, this.formNewLicense));
            } else {
                front.licenses.push(Object.assign({}, this.formNewLicense));
            }
            organizationApi.update({front: front}).then(res => {
                this.open_license = false;
                this.closeLicense();
            }).catch(error => {
                console.log(error);
                front.licenses = front.licenses.splice(front.licenses.length - 1, 1); 
            });
        },
        deleteLicense(license) {
            const front = this.$store.state.clinic.organization.form.front;
            front.licenses = front.licenses.filter(obj => obj.title !== license.title);
            organizationApi.update({front: front});
        },
        openCustomHeader() {
            this.openHeader = true;
        },
        edit_custom_header() {
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (!front.header) {
                front.header = {html: ''};
            } else {
                backup = Object.assign({}, front.header);
                front.header = Object.assign({}, this.formNewHeader);
            }
            organizationApi.update({front: front}).then(res => {
                this.openHeader = false;
                this.closeHeader();
            }).catch(error => {
                console.log(error);
                front.header = Object.assign({}, backup);
            });
        },
        openMainColor() {
            this.open_main_color = true;
        },
        edit_main_color() {
            const front = this.$store.state.clinic.organization.form.front;
            front.mainColor = {mainColor: this.formNewMainColor.mainColor};
            console.log(this.formNewMainColor);
            this.open_main_color = false;
            let backup; 
            if (!front.mainColor) {
                front.mainColor = {};
            } else {
                backup = Object.assign({}, front.mainColor);
                front.mainColor = Object.assign({}, this.formNewMainColor);
            }
            organizationApi.update({front: front}).then(res => {
                this.open_main_color = false;
                this.closeMainColor();
            }).catch(error => {
                console.log(error);
                front.mainColor = Object.assign({}, backup);
            });
        },
        colorMenu() {
            const front = this.$store.state.clinic.organization.form.front;
            if (front.mainColor) {
                //background: linear-gradient(to bottom, rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.1));
                
                const color = front.mainColor.mainColor;
                const r = parseInt(color.substr(1,2), 16);
                const g = parseInt(color.substr(3,2), 16);
                const b = parseInt(color.substr(5,2), 16);
                const c1 = `rgba(${r},${g},${b},1)`;
                const c075 = `rgba(${r},${g},${b},0.75)`;
                const c05 = `rgba(${r},${g},${b},0.5)`;
                const c025 = `rgba(${r},${g},${b},0.25)`;
                const c01 = `rgba(${r},${g},${b},0.1)`;
                const back = `linear-gradient(to bottom,${c01},${c025},${c05},${c075},${c1},${c1},${c1},${c1},${c075},${c05},${c025},${c01})`;
                return { background: back};
            }
            return {};
        },
        colorHead() {
            const front = this.$store.state.clinic.organization.form.front;
            if (front.mainColor) {
                return { background: front.mainColor.mainColor, color: front.mainColor.textColor};
            }
            return {};
        },
        backMenu() {
            const front = this.$store.state.clinic.organization.form.front;
            if (front.mainColor) {
                const color = front.mainColor.mainColor;
                const r = parseInt(color.substr(1,2), 16);
                const g = parseInt(color.substr(3,2), 16);
                const b = parseInt(color.substr(5,2), 16);
                const back = `rgba(${r},${g},${b},0.1)`;
                return { background: back};
            }
            return {};
        },
        itsMainPage() {
        const href = window.location.href.split('?')[0];
        console.log(href);
            if (this.$store.state.navigation.site) {
                const url = window.location.origin + '/';
                if (href === url) {
                return true;
                } else {
                return false;
                }
            } else {
                return false;
            }
        },
        openContentBackground() {
            this.isContentBackground = true;
        },
        edit_content_background() {
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (front.contentBackground) {
                backup = Object.assign({}, front.contentBackground);
            }
            if (this.typeBack === 'color') {
                front.contentBackground = Object.assign({}, this.contentBackground);
            } else {
                front.contentBackground = `url(${this.url_image})`;
            }
            organizationApi.update({front: front}).then(res => {
                this.closeContentBackground();
            }).catch(error => {
                console.log(error);
                front.contentBackground = Object.assign({}, backup);
            });
        },
        openImageLicense(link) {
            window.open(link, '_blank');
        },
        edit_YandexReviews() {
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (front.reviews) {
                backup = Object.assign({}, front.reviews);
            } else {
                backup = {};
            }
            front.reviews = this.reviewsYandex;
            organizationApi.update({front: front}).then(res => {
                this.closeYandexReviews();
            }).catch(error => {
                console.log(error);
                front.reviews = Object.assign({}, backup);
            });
        },
        edit_YandexMap() {
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (front.map) {
                backup = Object.assign({}, front.map);
            } else {
                backup = {};
            }
            front.map = this.mapYandex;
            organizationApi.update({front: front}).then(res => {
                this.closeYandexMap();
            }).catch(error => {
                console.log(error);
                front.map = Object.assign({}, backup);
            });
        },
        setUserMenu() {
            const payload = [
                {
                    title: 'Личный кабинет',
                    path: `clinics/${this.$store.state.clinic.organization.form.id}/personal-area`,
                    name: 'personal-area.main',
                    clinicName: this.$store.state.clinic.organization.form.id
                },
                {
                    title: 'Профиль пользователя',
                    name: 'index.profilepage'
                },
                {
                    title: 'Мои записи',
                    name: 'index.recordspage',
                }
            ];
            return payload;
        },
        setMainMenu() {
            const payload = [
        {
          title: 'Главная',
          name: 'main'
        },
     /*   {
              title: 'Модуль видеосвязи',
              name: 'vuexchat'
        }, */
        {
            title: 'Новости',
            path: '/news',
            name: 'news'
        },
        {
            title: 'Пациентам',
            path: '/patients',
            name: 'patients'
        },
        {
            title: 'Специалисты',
            path: '/specialists',
            name: 'specialists'
        },
        {
          title: 'Запись',
          path: `clinic/${this.$store.state.clinic.organization.form.id}`,
          name: 'clinic.public',
          clinicName: this.$store.state.clinic.organization.form.id
        },
        {
            title: 'Стандарты и порядки',
            path: '/standards',
            name: 'standards'
        },
        {
            title: 'Документы',
            path: '/documnets',
            name: 'documents'
        },
        /*{
          title: 'Личный кабинет',
          path: `clinics/${this.$store.state.clinic.organization.form.id}/personal-area`,
          name: 'personal-area.main',
          clinicName: this.$store.state.clinic.organization.form.id
        },*/
        {
          title: 'Контакты',
          path: '/contact',
          name: 'contact'
        }
      ];
      return payload;
        },
         resizeHandler({ target }) {
            const isDesktop = target.innerWidth > 1100;
            let bool;
            if (isDesktop) {
                if (!this.desktop) {
                bool = true;
                }
            } else if (this.desktop) {
                bool = false;
            }
            this.desktop = isDesktop;
            console.log(this.desktop);
        },
    }
    
};
</script>

<style lang="scss" scoped>
.swiper {
  height: 490px;
  width: 100%;
  padding: 1rem 0 2rem 0;

  .swiper-slide {
    display: flex;
    justify-content: center;
    //align-items: center;
    text-align: center;
    //font-weight: bold;
    width: 35%;
  }
}
.swiper-review {
  height: 300px;
  width: 100%;
  padding: 1rem 0 2rem 0;

  .swiper-slide {
    display: flex;
    justify-content: center;
    //align-items: center;
    text-align: center;
    //font-weight: bold;
    width: 50%;
  }
}
.swiper-license {
  height: 380px;
  width: 100%;
  padding: 1rem 0 2rem 0;

  .swiper-slide {
    display: flex;
    justify-content: center;
    //align-items: center;
    text-align: center;
    //font-weight: bold;
    width:25%;
  }
}

.custom-header {
    width: 100%;
    padding: 0rem 0 0rem 0;
    height: 190px;
    background: whitesmoke;
    display: flex;
}
.custom-header:hover {
    .settings {
        display: block;
    }
}
.back-header {
    background: linear-gradient(to top, white 48%,#d1212c 50%);
    display: flex;
    height: 190px;
    flex-direction: column;
    width:100%;
    margin:auto;
    //background: url(http://kardioservis.ru/css/images/header-background.png);
    background-size: cover;
    //box-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 0px 0 #b9b9b9, 0 5px 0 rgba(125, 125, 125, 0.2), 0 6px 1px rgba(0, 0, 0, 0.2), 0 0 5px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.2), 0 3px 5px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.2), 0 0 4px white, 0 0px 3px white, 1px 1px 5px rgba(255, 155, 0, 0.37), 1px 1px 10px rgba(102, 60, 0, 0.5); 
}
.logo {
    width: 25%;
    height: 190px;
    background: #6f42c1;
}
.head-title {
    width:100%;
    display: flex;
    height: 100px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.head-description {
    // #fc1717
    background: linear-gradient( #bbb, transparent 1px), linear-gradient( #bbb, transparent 2px), linear-gradient( 90deg, #bbb, transparent 1px),  linear-gradient( 90deg, #bbb, transparent 2px);
    background-size: 15px 15px, 75px 75px;
    // background-position: center center;
    display:flex;
    height: 82px;
    box-shadow: 0px 0px 0px 8px rgba(0,0,0,0.2);
    flex-direction: row;
    justify-content: center;
}
.head-phone {
    width:25%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.left-head {
    height: 190px;
    width: 25%;
    background:  #20c997;
}
.right-head {
    height: 190px;
    width: 25%;
    background:  #17a2b8;
}
.under-head {
    // background: radial-gradient(circle, #5c0067 0%, #00d4ff 100%);
    // background: rgba(209, 33, 44, 0.1);
    width: 100%;
    height: 30px;
}
.uslugi {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 1rem 8rem 1rem 8rem;
   
}
.team {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 1rem 8rem 1rem 8rem;
    width: 100%;
}
.reviews {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 1rem 8rem 1rem 8rem;
    width: 100%;
}
.licenses {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 1rem 8rem 1rem 8rem;
    width: 100%;
}
.license {
    width:200px; 
    height:282px; 
    display:flex; 
    justify-content:center; 
    align-items:center;
    transition: 0.35s;
    border: solid 1px gray;
    cursor:pointer;
    position: relative;
}
.del-lic {
    position: absolute;
    top: 10px;
    right:10px;
    display:none;
    opacity: 0.6;
}
.license:hover {
    box-shadow: 0 0 5px 3px gray;
    .del-lic {
        display: block;
    }
}
.add-lic {
    background: radial-gradient(circle, #ffffff, #c6c6c6);
}
.carousel {
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
}
.present {
    width:100%;
    padding: 1rem 8rem 1rem 8rem;
    display: flex;
    justify-content: space-evenly;
}
.left-present {
    display: flex;
    flex-direction: column;
    margin: 0 15px 0 15px;

}
.right-present {
    margin: 0 15px 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.under-present {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
}
.v_slider__item {
    width:100%
}
::v-deep .carousel-inner {
    border-radius: 15px;
}
::v-deep .slide {
    transition: 0.35s;
}
::v-deep .slide:hover {
    box-shadow: 0 0 15px 3px gray;
    .settings {
        display: block;
    }
}
::v-deep .carousel-caption {
    top: 40px;
}
.anyPresent {
    width: 450px;
    height: 192px;
    border-radius: 5px;
    box-shadow: 0 0 3px 1px lightgrey;
    margin-top: 15px;
    transition: 0.35s;
    padding: 1rem;
    text-align: center;
    overflow: auto;
}
.anyPresent:first-child {
    margin-top: 0;
}
.anyPresent-left {
    width: 320px;
    height: 192px; //250px;
    border-radius: 5px;
    box-shadow: 0 0 3px 1px lightgrey;
    transition: 0.35s;
    position: relative;
    padding: 1rem;
    text-align: center;
    overflow: auto;
}
.anyPresent-left:hover {
    box-shadow: 0 0 15px 3px lightgrey;
    .settingsBlock {
        display: block;
    }
}
.anyPresent:hover {
    box-shadow: 0 0 15px 3px lightgrey;
    position: relative;

    .settingsBlock {
        display: block;
    }
}
::v-deep .list-group-item {
    display:flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    width:150px;
    min-width: 150px;
    text-align: center;
    transition: 0.35s;
    background-size: cover !important;
    cursor: pointer;
    overflow-wrap: anywhere;
    padding: 0;
}
.edit-service {
    position:absolute;
    bottom:0;
    left:0;
    cursor:pointer;
    display: none;
    color: gray;
}
.delete-service {
    position:absolute;
    top:0;
    right:0;
    cursor:pointer;
    display: none;
    color: gray;
}
::v-deep .list-group-item:hover {
    box-shadow: 0 0 15px 3px gray;
    .edit-service {
        display: block;
    }
    .delete-service {
        display: block;
    }
}
::v-deep .list-group-item:nth-child(odd) {
    background: whitesmoke;
}
::v-deep .list-group-item:nth-child(even) {
    background: lightgray;
}
::v-deep .list-group {
    max-width: 100%;
    overflow-x: auto;
}
.row {
    display: flex;
    margin: 1rem;
}
::v-deep .card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 15rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    transition: 0.3s;
}
::v-deep .card:hover {
    box-shadow: 0 0 15px 3px gray;
}
::v-deep .card-header {
    display: flex;
    justify-content: center;
    background: radial-gradient(circle, #ffffff,  #c6c6c6, );
   // background-image: radial-gradient(circle, #ffffff, #ececec, #d8d8d8, #c6c6c6, #b3b3b3);
}
::v-deep .card-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;
    padding: 1.25rem;
}
.custom-menu {
    display: flex;
    width: 100%;
    padding: 0 2rem 0 2rem;
}
.custom-link {
    margin-left: 2px;
    text-align: center;
    height: 30px;
    padding: 0 1rem 0 1rem;
    transform: skew(20deg);
    color: white;
    background: linear-gradient(to bottom, rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.1));

    //background-image: linear-gradient(to bottom, #68cfe0, #8fd6ef, #b2ddf7, #d0e5fb, #e8eefc, #e8eefc, #e8eefc, #e8eefc, #d0e5fb, #b2ddf7, #8fd6ef, #68cfe0);
    cursor: pointer;
    transition: 0.3s;
    border-radius: 2px;
    outline: auto 1px lightgray;
}
.in-link {
    transform: skew(-20deg);
}
.custom-link:hover {
    box-shadow: 0 0 5px 3px gray;
    color:black;
    background: linear-gradient(to bottom, rgba(209, 33, 44, 1), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 1));

}

.custom-link1 {
    margin-left: 2px;
    text-align: center;
    height: 30px;
    padding: 0 1rem 0 1rem;
    color: white;
    background: linear-gradient(to bottom, rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 1), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.1));

    //background-image: linear-gradient(to bottom, #68cfe0, #8fd6ef, #b2ddf7, #d0e5fb, #e8eefc, #e8eefc, #e8eefc, #e8eefc, #d0e5fb, #b2ddf7, #8fd6ef, #68cfe0);
    cursor: pointer;
    transition: 0.3s;
    border-radius: 2px;
    outline: auto 1px lightgray;
}

.custom-link1:hover {
    box-shadow: 0 0 5px 3px gray;
    color:black;
    background: linear-gradient(to bottom, rgba(209, 33, 44, 1), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.1), rgba(209, 33, 44, 0.25), rgba(209, 33, 44, 0.5), rgba(209, 33, 44, 0.75), rgba(209, 33, 44, 1));

}

.vm-userbar-menu-avatar {
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  border-radius: 50%;
  background: #5281c0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  margin-right: 1rem;
  overflow: hidden;
}
.vm-userbar-menu-avatar img {
  max-width: 100%;
  max-height: 100%;
}

::v-deep .btn-secondary {
    color:black;
    background-color:transparent;
    border-color:transparent;
    height: 30px;
    padding: 0 12px 0 12px;
}
::v-deep .btn-secondary:hover {
    color:black;
    background-color:transparent;
    border-color:transparent;
}
::v-deep .btn-secondary.dropdown-toggle {
    color:white !important;
    background-color:transparent !important;
    border-color:transparent !important;
}
::v-deep .btn-secondary.dropdown-toggle:hover {
    color:black !important;
}
::v-deep .btn:focus, .btn.focus {
    outline:none !important;
    box-shadow: none !important;
}
.vm-userbar-menu-header {
  display: flex;
  padding: 1rem;
}

.settings {
    position: absolute;
    cursor: pointer;
    right: 0;
    top: 10px;
    display: none;
}
.settingsBlock {
    position: absolute;
    cursor: pointer;
    right: 10px;
    top: 10px;
    display: none;
    color: black;
}
.description {
    white-space: pre-wrap;
    text-shadow: 1px 1px 2px white, 0 0 1em white;
    font-size: 20px;
    font-weight: 400;
}
h4 {
    text-shadow: 1px 1px 2px white, 0 0 1em white;
}

.review {
  border: 2px solid #ccc;
  background-color: #eee;
  border-radius: 5px;
  padding: 16px;
  margin: 16px 0;
  max-height: 300px;
  width:80%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
}

.review::after {
  content: "";
  clear: both;
  display: table;
}

.review img {
  float: left;
  margin-right: 20px;
  border-radius: 50%;
}

.review span {
  font-size: 20px;
  margin-right: 15px;
}

.yandex-review {
    width:560px;
    height:800px;
    overflow:hidden;
    position:relative;
  //  max-height: 400px;
}
.more {
    position: absolute;
    bottom: 10px;
    left: 10px;
    cursor: pointer;
}
.more:hover {
    color: blue;
}

.maps {
    background: #d1212c; 
    width:100%; 
    display:flex;
    flex-direction:row; 
    justify-content:space-between; 
    box-shadow: inset 0px 0px 0px 8px rgba(0,0,0,0.2); 
    padding:8px;
}

.footer-menu {
    margin:1rem 0 1rem 2rem;
    color: white;
    font-weight: 600;
    font-size: 18px;
    a  {
        cursor: pointer;
    }
    li:hover {
        color: black;
    }
}

.edit-review {
    display:none;
    cursor:pointer;
}
.reviews:hover {
    .edit-review {
        display: inline-block;
    }
}
.conts {
    display:flex;
    flex-direction:row;
}
@media (max-width: 500px) {
  .review {
      text-align: center;
  }
  .review img {
      margin: auto;
      float: none;
      display: block;
  }
}


@media screen and (max-width: 1024px) {
.present {
    width:100%;
    padding: 1rem 1rem 1rem 1rem;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
}
.under-present {
    flex-direction: column;
}
.anyPresent-left {
    width:100%;
    margin-top:1rem;
}
.anyPresent {
    width:100%;
    margin-top:1rem;
}
.anyPresent:first-child {
    margin-top:1rem;
}
.slide{
    width: 100% !important;
}
.uslugi {
    padding: 1rem 1rem 1rem 1rem;
    max-width: 100%;
    overflow: auto;
}
.team {
    padding: 1rem 1rem 1rem 1rem;
}
.reviews {
    padding: 1rem 1rem 1rem 1rem;
}
.licenses {
    padding: 1rem 1rem 1rem 1rem;
}
.swiper-review {

  .swiper-slide {
  width: 100%;
  }
}
.swiper-license {
  .swiper-slide {
      width: 100%;
  }
}
.swiper-button-next {
    padding-left: 0;
}
.swiper {
  height: 490px;
  width: 100%;
  padding: 1rem 0 2rem 0;

  .swiper-slide {
      width:100%;
  }
}
.yandex-review {
    width:100%;
    height:800px;
    overflow:auto;
    position:relative;
  //  max-height: 400px;
}
.conts {
    display:flex;
    flex-direction:column;
}
}
</style>
